// 默认设置
export const TITLE_DEFAULT = '天时子平八字';
// 强弱页
export const TITLE_STRONG = '生日测测';
// 捐赠页面
export const TITLE_DONATE = '助力传统文化复兴 我来加油';
// 捐赠页:捐赠编辑
export const TITLE_DONATE_EDIT = '星星之火 可以燎原 我来点燃传承星火';
// 捐赠页:捐赠成功
export const TITLE_DONATE_SUC = '捐赠成功，转发分享';
// 五行穿衣
export const TITLE_DRESS = '五行穿衣';